<script>
import ActiveGiftCard from '@/components/header/ActiveGiftCart.vue';
import Logout from '@/components/header/Logout.vue';
import FavoritesHeaderLink from '@/components/header/FavoritesHeaderLink.vue';
import SearchIcon from '@/components/icons/SearchIcon.vue';
import { useTestAssortmentMenu } from '@/composables/useTestAssortmentMenu';

export default {
  components: {
    ActiveGiftCard,
    Logout,
    FavoritesHeaderLink,
    SearchIcon
  },
  inject: ['testAssortmentHomeSessionValue'],
  props: {
    logoUrl: {
      type: String,
      required: true
    },
    inverted: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasAnyGiftCards() {
      return this.$activeGiftCard?.giftCards?.length > 0;
    },
    getCategoryUrl() {
      if (useTestAssortmentMenu(this.$activeGiftCard, this.testAssortmentHomeSessionValue)) {
        return this.testAssortmentHomeSessionValue || '';
      }

      return this.$page.dataJson?.dataJson?.giftCardCategory?.url || this.$page.dataJson?.dataJson?.category?.url || '';
    },
    rootPathRedirectUrl() {
      return this.getCategoryUrl || this.$channel.rootPathRedirectUrl || '';
    },
    onRootPath() {
      return this.$route.pathname == this.rootPathRedirectUrl;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
};
</script>

<template>
  <div class="desktop-header">
    <div class="desktop-header__content">
      <div class="desktop-header__logo">
        <router-link v-if="!onRootPath" :to="rootPathRedirectUrl" class="desktop-header__logo-link">
          <img :src="logoUrl" alt="logo" />
        </router-link>
        <img v-else :src="logoUrl" alt="logo" @click="scrollToTop" />
      </div>
      <div class="desktop-header__other-actions" v-if="hasAnyGiftCards && !inverted">
        <favorites-header-link />
        <button
          type="button"
          aria-label="Search"
          class="btn-bare desktop-header__search-btn text-foreground transition-colors hover:opacity-70"
          @click="$mitt.emit('Search:Open')"
        >
          <SearchIcon class="h-5 w-5" />
        </button>
        <active-gift-card />
      </div>
    </div>
  </div>
</template>

<style>
.desktop-header {
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 1rem 1rem 7px;
  max-width: calc(var(--site-max-width) + 2rem);
}

.desktop-header__content {
  display: flex;
  justify-content: space-between;
  height: 42px;
  position: relative;
}

.desktop-header__logo {
  width: 100%;
  height: 35px;
  display: flex;
  justify-content: space-around;
  align-self: center;
  align-items: center;
}

.desktop-header__logo img {
  cursor: pointer;
  height: 35px;
}

.desktop-header__other-actions {
  position: absolute;
  right: 0;
  display: flex;
  grid-auto-flow: column;
  align-items: center;
  gap: 25px;
  height: 42px;
}

.desktop-header__search-btn {
  cursor: pointer;
}
</style>
